import React from 'react';

import { 
	Box,
	Container, 
	Typography 
} from '@mui/material';

import styles from "../../global.scss";
import "./styles.scss";

const PrivacyPolicyPage = () => {
  return (
    <Container maxWidth="xl">
      <Box className="privacy">
        <Box sx={{ margin: "15px 0px 50px 0px", borderRadius: "30px", backgroundColor: styles["primary_light"], height: "250px" }} 
          className="flexCenterCenterRow">
          <Typography
            sx={{ 
              textAlign: "center",
              typography: { xs: "h4", sm: "h4", md: "h3", lg: "h3" },
            }}>Privacy policy</Typography>
        </Box>
        <Typography variant='subtitle2' mb={"40px"} sx={{ textAlign: "center", color: "grey" }}>
          Last updated: February 12, 2026<br/>
          Version: 1.0
        </Typography>


        <Typography variant='h5' mb={"20px"}>1. Introduction</Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          LusidPay Inc. (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) respects your privacy and is committed to protecting the
          personal and business information of our clients. This Privacy Policy outlines how we collect,
          use, safeguard, and disclose information when you use our website, applications, and suite of
          services, including our billing, invoicing, and payment platforms, as well as our Lusid Trade
          (compliance and audit defense) and Lusid Certify (certification support) services.
        </Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          This policy applies to all clients, including small and medium-sized businesses (SMBs),
          importers, exporters, and any authorized users interacting with our platform.
        </Typography>

        <Typography variant='h5' mb={"20px"}>2. Information We Collect</Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          To provide comprehensive financial and trade compliance services, we collect various types of information:
        </Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          <ul style={{ marginLeft: "40px" }}>
          <li>
          <p><strong>Identity &amp; Contact Information:</strong> First and last name, email address, physical address, phone number, and professional title.</p>
          </li>
          <li>
          <p><strong>Business &amp; Corporate Information:</strong> Company name, Employer Identification Number (EIN), corporate structure, ultimate beneficial owner (UBO) details, and authorized representative information.</p>
          </li>
          <li>
          <p><strong>Financial &amp; Transactional Information:</strong> Bank account details, routing numbers, transaction history, invoice details, payment flow data, and foreign exchange (FX) records.</p>
          </li>
          <li>
          <p><strong>Trade &amp; Compliance Information:</strong> Customs documentation, supply chain records, import/export data, and documentation provided specifically for audit defense or certification support (Lusid Certify / Lusid Trade).</p>
          </li>
          <li>
          <p><strong>Technical &amp; Usage Data:</strong> IP addresses, browser types, device identifiers, and platform usage analytics to monitor security and improve user experience.</p>
          </li>
          </ul>
        </Typography>

        <Typography variant='h5' mb={"20px"}>3. How We Use Your Information</Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          We use the collected information for the following business and legal purposes:
        </Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          <ul style={{ marginLeft: "40px" }}>
          <li>
          <p><strong>Service Delivery:</strong> To facilitate cross-border and domestic payments, process invoices, execute FX transactions, and manage required reserves.</p>
          </li>
          <li>
          <p><strong>Trade &amp; Certification Support:</strong> To analyze trade data for audit defense and to assist in the preparation and submission of business certifications.</p>
          </li>
          <li>
          <p><strong>Risk &amp; Security:</strong> To verify user identities, detect and prevent fraud, and secure our infrastructure.</p>
          </li>
          <li>
          <p><strong>Compliance (KYC/AML):</strong> To perform mandatory &quot;Know Your Customer&quot; (KYC) checks, sanctions screening, and ongoing transaction monitoring as required by financial regulators.</p>
          </li>
          </ul>
        </Typography>

        <Typography variant='h5' mb={"20px"}>4. Information Sharing and Disclosure</Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          We do not sell, rent, or trade your personal or business data. We only share information under the following circumstances:
        </Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          <ul style={{ marginLeft: "40px" }}>
          <li>
          <p><strong>Banking &amp; Payment Partners:</strong> With our underlying bank partners and payment facilitators (e.g., CurrencyCloud) strictly for the purpose of executing your requested financial transactions and fulfilling regulatory obligations.</p>
          </li>
          <li>
          <p><strong>Service Providers:</strong> With verified US-based third-party vendors who provide necessary infrastructure (e.g., secure cloud hosting, identity verification).</p>
          </li>
          <li>
          <p><strong>Legal &amp; Regulatory Authorities:</strong> When required by law, subpoena, or regulatory audit (e.g., FinCEN, OFAC, Customs and Border Protection) to comply with state and federal regulations.</p>
          </li>
          </ul>
        </Typography>

        <Typography variant='h5' mb={"20px"}>5. Data Retention Policy</Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          We will retain your information only for as long as is necessary for the purposes set out in this Privacy Policy.
        </Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          <ul style={{ marginLeft: "40px" }}>
          <li>
          <p><strong>Financial &amp; Regulatory Records:</strong> As a US financial services provider, we are subject to stringent legal and regulatory record-keeping obligations. In accordance with applicable Anti-Money Laundering (AML), Counter-Terrorism Financing (CTF), and Bank Secrecy Act (BSA) regulations, we retain all customer identification information (KYC) and transaction records for a minimum of five (5) years following the termination of the business relationship or the date of the final transaction.</p>
          </li>
          <li>
          <p><strong>Legal &amp; Policy Enforcement:</strong> We retain data to the extent necessary to comply with tax laws, resolve disputes, enforce legal agreements, and maintain our audit defense capabilities.</p>
          </li>
          <li>
          <p><strong>Data Destruction:</strong> Once the legal retention period expires and there is no ongoing legitimate business need, your data is securely deleted or irreversibly anonymized.</p>
          </li>
          </ul>
        </Typography>

        <Typography variant='h5' mb={"20px"}>6. Data Processing and Localization</Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          <strong>Strict US-Based Processing:</strong> Your information, including Personal and Business Data, is processed, stored, and maintained exclusively on secure servers located within the United States.
          LusidPay Inc. strictly adheres to data localization principles for our core financial operations. We do not transfer, process, or store your personal or financial transaction data in jurisdictions outside of the United States.
        </Typography>

        <Typography variant='h5' mb={"20px"}>7. Data Security</Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          We implement enterprise-grade, bank-level security measures designed to protect your data from unauthorized access, alteration, disclosure, or destruction. This includes end-to-end encryption for data in transit and at rest, multi-factor authentication (MFA), role-based access controls, and continuous network monitoring.
        </Typography>

        <Typography variant='h5' mb={"20px"}>8. Your Data Rights</Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          Depending on your state of residence (e.g., California under the CCPA/CPRA), you may have certain rights regarding your personal data, including the right to:
        </Typography>
        <Typography variant='body1' mb={"20px"} sx={{ color: "grey" }}>
          <ul style={{ marginLeft: "40px" }}>
          <li>Access the specific data we have collected about you.</li>
          <li>Request corrections to inaccurate or incomplete data.</li>
          <li>Request deletion of your data.</li>
          </ul>
        </Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          <strong>Important Notice Regarding Deletion Requests:</strong> Because LusidPay Inc. operates in the highly regulated financial sector, your &quot;right to be forgotten&quot; or to request data deletion is superseded by our federal legal obligation to retain financial transaction and identity records for the mandated five (5) year AML/BSA period. Deletion requests will be honored for non-essential marketing data, but regulated financial data will be placed in a secure, isolated hold until the statutory retention period expires.
        </Typography>

        <Typography variant='h5' mb={"20px"}>9. Changes to this Privacy Policy</Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          We may update Our Privacy Policy from time to time to reflect changes in regulatory frameworks or our service offerings. We will notify you of any changes by posting the new Privacy Policy on this page and updating the &quot;Effective Date&quot; at the top.
        </Typography>

        <Typography variant='h5' mb={"20px"}>10. Contact Us</Typography>
        <Typography variant='body1' mb={"40px"} sx={{ color: "grey" }}>
          If you have any questions about this Privacy Policy, our data practices, or wish to exercise your data rights, please contact our privacy and compliance team:
          <ul style={{ marginLeft: "40px" }}>
          <li>LusidPay Inc.</li>
          <li>Location: Fairfax, VA</li>
          <li>Email: <a href="mailto:compliance@lusidpay.com" style={{ color: "#1976d2", textDecoration: "underline" }}>compliance@lusidpay.com</a></li>
          <li>Website: <a href={"https://lusidpay.com"} rel="noreferrer" target="_blank" style={{ color: "#1976d2", textDecoration: "underline" }}>https://lusidpay.com</a></li>
          </ul>
        </Typography>



        
      </Box>
    </Container>
  )
}

export default PrivacyPolicyPage